var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g, _path29, _g2, _path30, _g3, _path31, _g4, _path32, _g5, _path33, _g6, _path34, _g7, _path35, _g8, _path36, _g9, _path37, _g10, _path38, _g11, _path39, _g12, _path40, _g13, _path41, _g14, _path42, _g15, _path43, _g16, _path44, _g17, _path45, _g18, _path46, _g19, _path47, _g20, _path48, _path49, _g21, _path50, _g22, _path51, _g23, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBae(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 300,
    viewBox: "0 0 380 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_337_68)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.195 171.134V179.31H127.821C128.897 179.31 129.435 178.664 129.435 177.374V173.069C129.435 172.158 129.099 171.555 128.427 171.266C128.231 171.179 127.88 171.135 127.363 171.135H126.195V171.134ZM126.195 158.886V167.061H127.363C127.88 167.061 128.231 167.021 128.427 166.944C129.099 166.644 129.435 166.038 129.435 165.126V160.835C129.435 159.534 128.897 158.886 127.821 158.886H126.195ZM122.486 154.828H128.204C131.497 154.839 133.146 156.839 133.146 160.836V165.127C133.146 166.999 132.467 168.322 131.112 169.1C132.467 169.876 133.146 171.2 133.146 173.071V177.375C133.146 181.362 131.418 183.358 127.966 183.369H122.486V154.829V154.828Z",
    fill: "#216B4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.295 173.243L141.879 161.375L140.463 173.243H143.296H143.295ZM147.044 173.243L148.248 183.369H144.5L143.778 177.318H139.989L139.255 183.369H135.517L136.724 173.287L139.349 154.828H144.436L147.045 173.242L147.044 173.243Z",
    fill: "#216B4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.017 154.828H154.728L158.242 171.382V154.828H161.677V183.368H157.965L154.584 167.337V183.368H151.017V154.828Z",
    fill: "#216B4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M176.022 177.828C176.022 181.823 174.241 183.824 170.685 183.835C167.136 183.835 165.362 181.833 165.362 177.828V160.369C165.362 156.375 167.136 154.379 170.685 154.379C174.234 154.379 176.022 156.376 176.022 160.369V164.212H172.311V160.369C172.311 159.091 171.774 158.446 170.699 158.435H170.672C169.604 158.435 169.072 159.08 169.072 160.369V177.828C169.072 179.116 169.611 179.763 170.685 179.763C171.76 179.763 172.31 179.117 172.31 177.828V171.136H170.435V167.063H176.021V177.828H176.022Z",
    fill: "#216B4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M179.703 183.368V154.828H183.415V179.309H189.327V183.368H179.703Z",
    fill: "#216B4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.692 173.243L197.274 161.375L195.859 173.243H198.692ZM202.44 173.243L203.646 183.369H199.896L199.176 177.318H195.386L194.652 183.369H190.913L192.122 173.287L194.745 154.828H199.832L202.44 173.242V173.243Z",
    fill: "#216B4D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M210.122 158.886V179.31H211.745C212.822 179.31 213.359 178.664 213.359 177.374V160.836C213.359 159.535 212.822 158.887 211.745 158.887H210.122V158.886ZM206.409 154.828H212.128C215.422 154.839 217.07 156.839 217.07 160.836V177.374C217.07 181.361 215.343 183.357 211.89 183.368H206.408V154.828H206.409Z",
    fill: "#216B4D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M220.755 154.828H230.378V158.886H224.466V167.061H229.552V171.134H224.466V179.31H230.378V183.368H220.755V154.828Z",
    fill: "#216B4D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M233.408 160.372C233.408 156.376 235.183 154.379 238.732 154.379C242.281 154.379 244.068 156.376 244.068 160.372V164.213H240.357V160.372C240.357 159.092 239.819 158.446 238.743 158.436H238.717C237.649 158.436 237.118 159.081 237.118 160.372V162.959C237.118 164.231 238.277 165.788 240.591 167.63C242.911 169.463 244.068 171.659 244.068 174.22V177.828C244.068 181.833 242.293 183.835 238.743 183.835C235.185 183.826 233.408 181.821 233.408 177.828V173.986H237.118V177.828C237.118 179.117 237.659 179.763 238.743 179.763C239.827 179.763 240.357 179.117 240.357 177.828V174.568C240.357 173.192 239.199 171.583 236.881 169.739C234.565 167.906 233.408 165.676 233.408 163.048V160.373V160.372Z",
    fill: "#216B4D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M247.752 154.828H251.464V167.061H254.702V154.828H258.412V183.368H254.702V171.134H251.464V183.368H247.752V154.828Z",
    fill: "#216B4D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M150.658 231.652V233.077H147.524V238.287H151.161V239.711H146.03V225.018H151.161V226.444H147.524V231.652H150.658Z",
    fill: "#216B4D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M158.091 225.018L159.849 230.209L161.631 225.018H163.099L160.585 232.366L163.099 239.712H161.631L159.849 234.519L158.091 239.712H156.623L159.115 232.366L156.623 225.018H158.091Z",
    fill: "#216B4D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M174.73 237.133C174.73 239.038 173.767 239.994 171.839 239.999C169.917 239.999 168.957 239.044 168.957 237.133V227.663C168.957 225.757 169.917 224.805 171.839 224.805C173.761 224.805 174.73 225.757 174.73 227.663V229.36H173.24V227.663C173.24 226.713 172.776 226.234 171.848 226.229H171.833C170.911 226.229 170.448 226.707 170.448 227.663V237.133C170.448 238.088 170.913 238.565 171.839 238.565C172.765 238.565 173.24 238.088 173.24 237.133V235.436H174.73V237.133Z",
    fill: "#216B4D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M181.031 225.018H182.523V231.652H185.314V225.018H186.804V239.712H185.314V233.076H182.523V239.712H181.031V225.018Z",
    fill: "#216B4D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M197.434 235.003L196.11 226.265L194.78 235.003H197.433H197.434ZM198.893 234.663L199.591 239.712H198.076L197.632 236.43H194.604L194.152 239.712H192.646L193.327 234.698L194.887 225.018H197.342L198.893 234.663Z",
    fill: "#216B4D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M205.434 225.018H207.001L209.884 236.946V225.051L211.207 225.026V239.712H209.639L206.841 228.038V239.712H205.434V225.018Z",
    fill: "#216B4D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M223.358 237.133C223.358 239.038 222.395 239.994 220.467 239.999C218.546 239.999 217.584 239.044 217.584 237.133V227.663C217.584 225.757 218.546 224.805 220.467 224.805C222.387 224.805 223.358 225.757 223.358 227.663V229.36H221.868V227.663C221.868 226.713 221.403 226.234 220.475 226.229H220.459C219.537 226.229 219.075 226.707 219.075 227.663V237.133C219.075 238.088 219.539 238.565 220.466 238.565C221.392 238.565 221.867 238.088 221.867 237.133V233.119H220.712V231.686H223.357V237.132L223.358 237.133Z",
    fill: "#216B4D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M234.361 231.652V233.077H231.227V238.287H234.868V239.711H229.736V225.018H234.868V226.444H231.227V231.652H234.361Z",
    fill: "#216B4D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M130.706 208.018L128.327 190.3L125.933 208.018H130.706ZM133.331 207.338L134.581 217.576H131.86L131.063 210.927H125.619L124.809 217.576H122.098L123.324 207.397L126.128 187.77H130.539L133.331 207.338Z",
    fill: "#216B4D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M147.768 190.649V201.221H149.419C150.077 201.221 150.559 201.164 150.861 201.053C151.904 200.568 152.428 199.649 152.428 198.297V193.588C152.428 191.627 151.6 190.649 149.938 190.649H147.767H147.768ZM145.086 187.77H150.368C153.529 187.781 155.11 189.718 155.11 193.588V198.297C155.11 201.154 153.964 202.992 151.674 203.808C151.113 204.02 150.276 204.128 149.157 204.128H147.768V217.576H145.086V187.77Z",
    fill: "#216B4D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M168.845 190.649V201.221H170.497C171.156 201.221 171.636 201.164 171.939 201.053C172.983 200.568 173.507 199.649 173.507 198.297V193.588C173.507 191.627 172.677 190.649 171.017 190.649H168.845ZM166.164 187.77H171.445C174.607 187.781 176.188 189.718 176.188 193.588V198.297C176.188 201.154 175.041 202.992 172.752 203.808C172.192 204.02 171.353 204.128 170.234 204.128H168.845V217.576H166.164V187.77Z",
    fill: "#216B4D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M193.427 208.018L191.047 190.3L188.654 208.018H193.427ZM196.052 207.338L197.302 217.576H194.581L193.784 210.927H188.34L187.53 217.576H184.819L186.044 207.397L188.848 187.77H193.26L196.052 207.338Z",
    fill: "#216B4D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M210.486 190.649V201.221H212.139C212.797 201.221 213.279 201.164 213.58 201.053C214.624 200.568 215.149 199.649 215.149 198.297V193.588C215.149 191.627 214.32 190.649 212.659 190.649H210.486ZM207.807 187.77H213.088C216.249 187.781 217.83 189.718 217.83 193.588V198.297C217.83 200.7 216.689 202.366 214.407 203.295L218.931 217.576H215.96L212.222 203.688L210.487 203.794V217.576H207.808V187.77H207.807Z",
    fill: "#216B4D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M237.618 201.218V204.127H231.979V214.698H238.523V217.576H229.298V187.77H238.523V190.649H231.979V201.218H237.618Z",
    fill: "#216B4D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M249.575 217.575V187.77H252.256V214.698H258.801V217.575H249.575Z",
    fill: "#216B4D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M241.229 233.031H258.898V231.775H241.229",
    fill: "#286647"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M122 233.031H139.668V231.775H122",
    fill: "#286647"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 200,
    y: 96,
    width: 9,
    height: 10
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M200.497 101.044L204.459 105.219L208.421 101.044L204.459 96.8711L200.497 101.044Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.422 96.8711H200.497V105.218H208.422V96.8711Z",
    fill: "url(#paint0_linear_337_68)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 84,
    width: 9,
    height: 9
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M188.521 88.5167L192.484 92.6915L196.445 88.5167L192.484 84.3418L188.521 88.5167Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.445 84.3418H188.521V92.6915H196.445V84.3418Z",
    fill: "url(#paint1_linear_337_68)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 109,
    width: 9,
    height: 10
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M188.521 113.872L192.484 118.047L196.445 113.872L192.484 109.695L188.521 113.872Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.445 109.695H188.521V118.047H196.445V109.695Z",
    fill: "url(#paint2_linear_337_68)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 176,
    y: 96,
    width: 9,
    height: 10
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M176.4 101.143L180.363 105.318L184.325 101.143L180.363 96.9688L176.4 101.143Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.325 96.9688H176.4V105.318H184.325V96.9688Z",
    fill: "url(#paint3_linear_337_68)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 155,
    y: 97,
    width: 5,
    height: 8
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M156.524 104.678L159.882 101.145L156.524 97.6094C153.287 101.52 156.524 104.678 156.524 104.678Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.883 97.6094H153.287V104.678H159.883V97.6094Z",
    fill: "url(#paint4_linear_337_68)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 224,
    y: 97,
    width: 6,
    height: 8
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M224.631 101.071L227.989 104.605C227.989 104.605 231.227 101.443 227.989 97.5352L224.631 101.072V101.071Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.227 97.5352H224.631V104.605H231.227V97.5352Z",
    fill: "url(#paint5_linear_337_68)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 189,
    y: 135,
    width: 7,
    height: 6
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M189.016 138.783C190.252 139.92 191.411 140.3 192.408 140.3C194.395 140.3 195.73 138.783 195.73 138.783L192.374 135.248L189.017 138.783H189.016Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.73 135.248H189.016V140.3H195.73V135.248Z",
    fill: "url(#paint6_linear_337_68)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 61,
    width: 8,
    height: 7
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M188.945 63.5055L192.302 67.0401L195.658 63.5055C195.658 63.5055 194.324 61.9883 192.335 61.9883C191.339 61.9883 190.18 62.3671 188.944 63.5055",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.658 61.9883H188.945V67.0401H195.658V61.9883Z",
    fill: "url(#paint7_linear_337_68)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 153,
    y: 85,
    width: 14,
    height: 14
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M154.254 86.1145C153.165 87.2612 153.165 89.1417 154.254 90.2914L162.414 98.8872L166.378 94.7082L158.217 86.1145C157.673 85.5422 156.955 85.252 156.235 85.252C155.514 85.252 154.8 85.5422 154.254 86.1145Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.378 85.252H153.165V98.8861H166.378V85.252Z",
    fill: "url(#paint8_linear_337_68)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 194,
    y: 103,
    width: 29,
    height: 30
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M194.612 107.616L217.462 131.597C218.007 132.171 218.726 132.457 219.444 132.457C220.163 132.457 220.88 132.171 221.426 131.597C222.516 130.448 222.516 128.571 221.426 127.423L198.576 103.443L194.612 107.616Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.516 103.443H194.612V132.458H222.516V103.443Z",
    fill: "url(#paint9_linear_337_68)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 218,
    y: 103,
    width: 14,
    height: 15
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M218.541 107.526L226.748 116.174C227.296 116.748 228.012 117.033 228.731 117.033C229.449 117.033 230.167 116.747 230.711 116.174C231.799 115.024 231.799 113.146 230.711 111.999L222.503 103.352L218.54 107.526H218.541Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.8 103.352H218.541V117.033H231.8V103.352Z",
    fill: "url(#paint10_linear_337_68)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 177,
    y: 116,
    width: 26,
    height: 27
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M178.059 137.353C176.968 138.502 176.968 140.381 178.059 141.529C178.605 142.103 179.321 142.388 180.041 142.388C180.76 142.388 181.477 142.103 182.022 141.529L202.264 120.204L198.301 116.029L178.058 137.353H178.059Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.264 116.029H176.967V142.388H202.264V116.029Z",
    fill: "url(#paint11_linear_337_68)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 206,
    y: 85,
    width: 26,
    height: 27
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M226.602 86.2152L206.56 107.331L210.521 111.505L230.567 90.389C231.656 89.2423 231.656 87.3628 230.567 86.2141C230.023 85.6398 229.303 85.3516 228.585 85.3516C227.866 85.3516 227.148 85.6398 226.601 86.2141",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.657 85.3516H206.56V111.504H231.657V85.3516Z",
    fill: "url(#paint12_linear_337_68)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 182,
    y: 60,
    width: 26,
    height: 27
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M202.653 60.9611L182.598 82.0846L186.563 86.2584L206.616 65.1339C207.706 63.9873 207.706 62.1098 206.616 60.9611C206.071 60.3868 205.354 60.0996 204.634 60.0996C203.913 60.0996 203.197 60.3868 202.653 60.9611Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.706 60.0996H182.598V86.2584H207.706V60.0996Z",
    fill: "url(#paint13_linear_337_68)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 153,
    y: 90,
    width: 26,
    height: 28
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M154.108 112.099C153.017 113.246 153.017 115.124 154.108 116.273C154.653 116.847 155.368 117.133 156.089 117.133C156.809 117.133 157.524 116.847 158.07 116.273L178.302 94.9621L174.34 90.7852L154.108 112.098V112.099Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.302 90.7852H153.016V117.133H178.302V90.7852Z",
    fill: "url(#paint14_linear_337_68)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 162,
    y: 69,
    width: 61,
    height: 64
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M217.624 70.4679L163.597 127.381C162.507 128.529 162.507 130.409 163.597 131.556C164.14 132.129 164.859 132.417 165.578 132.417C166.296 132.417 167.014 132.129 167.559 131.556L221.586 74.6428C222.676 73.4951 222.676 71.6166 221.586 70.469C221.042 69.8956 220.323 69.6074 219.605 69.6074C218.887 69.6074 218.168 69.8956 217.624 70.469",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.676 69.6055H162.506V132.415H222.676V69.6055Z",
    fill: "url(#paint15_linear_337_68)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 177,
    y: 60,
    width: 14,
    height: 14
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M178.205 60.8584C177.114 62.0092 177.114 63.8877 178.205 65.0354L186.368 73.6342L190.329 69.4593L182.167 60.8584C181.623 60.2861 180.905 60 180.186 60C179.466 60 178.75 60.2872 178.205 60.8584Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.329 60H177.114V73.6342H190.329V60Z",
    fill: "url(#paint16_linear_337_68)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 206,
    y: 90,
    width: 9,
    height: 9
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M206.605 94.9561L210.327 98.8737L214.288 94.6988L210.571 90.7812L206.605 94.9561Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.288 90.7812H206.605V98.8737H214.288V90.7812Z",
    fill: "url(#paint17_linear_337_68)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 182,
    y: 116,
    width: 9,
    height: 9
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M182.645 120.196L186.364 124.116L190.327 119.941L186.606 116.021L182.645 120.196Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.327 116.021H182.645V124.116H190.327V116.021Z",
    fill: "url(#paint18_linear_337_68)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 194,
    y: 78,
    width: 9,
    height: 9
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M194.605 82.3136L198.355 86.2579L202.315 82.0841L198.569 78.1367L194.605 82.3136Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.316 78.1367H194.605V86.2579H202.316V78.1367Z",
    fill: "url(#paint19_linear_337_68)"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M163.597 70.7081C162.507 71.8568 162.507 73.7352 163.597 74.8819L176.488 88.5202L176.485 88.5243L180.447 92.7002L180.45 92.693L186.347 98.9049L190.31 94.73L184.415 88.5202L184.417 88.5161L180.455 84.3422L180.45 84.3464L167.558 70.7081C167.014 70.1358 166.296 69.8496 165.578 69.8496C164.859 69.8496 164.141 70.1358 163.596 70.7081",
    fill: "url(#paint20_linear_337_68)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 162,
    y: 69,
    width: 29,
    height: 30
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M163.597 70.7081C162.507 71.8568 162.507 73.7352 163.597 74.8819L176.488 88.5202L176.485 88.5243L180.447 92.7002L180.45 92.693L186.347 98.9049L190.31 94.73L184.415 88.5202L184.417 88.5161L180.455 84.3422L180.45 84.3464L167.558 70.7081C167.014 70.1358 166.296 69.8496 165.578 69.8496C164.859 69.8496 164.141 70.1358 163.596 70.7081",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.309 69.8496H162.506V98.9069H190.309V69.8496Z",
    fill: "url(#paint21_linear_337_68)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 170,
    y: 103,
    width: 9,
    height: 9
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M170.62 107.53L174.39 111.502L178.352 107.328L174.582 103.355L170.62 107.53Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.352 103.355H170.62V111.502H178.352V103.355Z",
    fill: "url(#paint22_linear_337_68)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_337_68",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 194,
    y: 128,
    width: 14,
    height: 15
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M194.502 132.955L202.709 141.602C203.254 142.178 203.974 142.463 204.689 142.463C205.405 142.463 206.126 142.177 206.671 141.602C207.762 140.456 207.762 138.575 206.671 137.429L198.462 128.779L194.5 132.956L194.502 132.955Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_337_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.763 128.779H194.502V142.464H207.763V128.779Z",
    fill: "url(#paint23_linear_337_68)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_337_68",
    x1: 201.065,
    y1: 101.343,
    x2: 208.995,
    y2: 101.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_337_68",
    x1: 187.727,
    y1: 88.1001,
    x2: 195.639,
    y2: 88.1001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_337_68",
    x1: 187.727,
    y1: 113.458,
    x2: 195.639,
    y2: 113.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_337_68",
    x1: 176.05,
    y1: 100.967,
    x2: 183.981,
    y2: 100.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_337_68",
    x1: 152.247,
    y1: 99.6006,
    x2: 157.051,
    y2: 99.6006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_337_68",
    x1: 226.635,
    y1: 102.163,
    x2: 231.423,
    y2: 102.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_337_68",
    x1: 186.55,
    y1: 136.477,
    x2: 193.27,
    y2: 136.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_337_68",
    x1: 186.475,
    y1: 63.2016,
    x2: 193.18,
    y2: 63.2016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_337_68",
    x1: 154.389,
    y1: 92.5555,
    x2: 167.338,
    y2: 92.5555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_337_68",
    x1: 192.205,
    y1: 116.751,
    x2: 219.86,
    y2: 116.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_337_68",
    x1: 219.767,
    y1: 110.797,
    x2: 232.734,
    y2: 110.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_337_68",
    x1: 178.098,
    y1: 129.599,
    x2: 203.077,
    y2: 129.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_337_68",
    x1: 203.664,
    y1: 97.0083,
    x2: 228.501,
    y2: 97.0083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_337_68",
    x1: 179.868,
    y1: 71.8329,
    x2: 204.729,
    y2: 71.8329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_337_68",
    x1: 150.639,
    y1: 102.628,
    x2: 175.608,
    y2: 102.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_337_68",
    x1: 160.701,
    y1: 100.006,
    x2: 220.362,
    y2: 100.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_337_68",
    x1: 176.319,
    y1: 66.2673,
    x2: 189.272,
    y2: 66.2673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_337_68",
    x1: 208.297,
    y1: 95.7102,
    x2: 215.984,
    y2: 95.7102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_337_68",
    x1: 184.801,
    y1: 121.188,
    x2: 192.471,
    y2: 121.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_337_68",
    x1: 194.639,
    y1: 82.2202,
    x2: 202.354,
    y2: 82.2202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_337_68",
    x1: 162.779,
    y1: 84.3783,
    x2: 190.31,
    y2: 84.3783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_337_68",
    x1: 159.669,
    y1: 82.794,
    x2: 187.137,
    y2: 82.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_337_68",
    x1: 169.059,
    y1: 106.613,
    x2: 176.781,
    y2: 106.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_337_68",
    x1: 194.59,
    y1: 135.686,
    x2: 207.581,
    y2: 135.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A91F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#641313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#641313"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_337_68"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136.898,
    height: 180,
    fill: "white",
    transform: "translate(122 60)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBae);
export default __webpack_public_path__ + "static/media/bae.d5eec60b36a4b98b5064a610fdfb557d.svg";
export { ForwardRef as ReactComponent };